import axios from 'axios';

/**
 * Extract a human-readable message from an unknown thrown value.
 *
 * Handles the shapes this app actually throws: axios errors whose response
 * body is `{ error?: string; message?: string }`, plain `Error` instances,
 * and anything else (falls back to the provided default). Use this in
 * `catch` clauses instead of typing the caught value as `any`.
 */
function envelopeErrorMessage(data: unknown): string | undefined {
  if (!data || typeof data !== 'object') return undefined;
  const rec = data as { error?: unknown; message?: unknown };
  if (typeof rec.error === 'string' && rec.error) return rec.error;
  if (rec.error && typeof rec.error === 'object') {
    const msg = (rec.error as { message?: unknown }).message;
    if (typeof msg === 'string' && msg) return msg;
  }
  if (typeof rec.message === 'string' && rec.message) return rec.message;
  return undefined;
}

export function getApiErrorMessage(
  error: unknown,
  fallback = 'Something went wrong',
): string {
  if (axios.isAxiosError(error)) {
    return envelopeErrorMessage(error.response?.data) || error.message || fallback;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return fallback;
}
